import { useState } from "react";
import PageHeading from "../../../PageHeading";
import OfficeDepositorList from "./OfficeDepositor/OfficeDepositorList";
import OfficeSectorList from "./OfficeSector/OfficeSectorList";
import OfficeExpenseItemList from "./OfficeExpenses/OfficeExpenseItemList";

const OfficeConfig = () => {
  const [activeTab, setActiveTab] = useState("Depositors");

  const tabs = [
    {
      name: "Depositors",
      content: (
        <div className="tab-content">
           <OfficeDepositorList />
        </div>
      ),
    },
    {
      name: "Deposit Sectors",
      content: (
        <div className="tab-content">
           <OfficeSectorList />
        </div>
      ),
    },
    {
      name: "Expense Items",
      content: (
        <div className="tab-content">
           <OfficeExpenseItemList />
        </div>
      ),
    },
  ];

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Office Accounts" },
    { label: "Office Config" },
  ];

  return (
    <div>
      <div className="print-hidden">
        <PageHeading title="Office Configuration" breadcrumbs={breadcrumbs} />
      </div>
      <div className="hospital-container flex flex-col xl:flex-row gap-5 items-start">
        {/* Left-side tabs (Sidebar) */}
        <div className="tab-list flex w-full flex-col sm:flex-row xl:flex-col xl:w-64 shrink-0 bg-white border-r border-gray-200 shadow-sm rounded-lg overflow-hidden">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button w-full text-center xl:text-left py-3 px-2 xl:px-4 text-xs xl:text-sm font-medium text-gray-700 border-b border-gray-200 transition-colors duration-200 ${
                activeTab === tab.name
                  ? "bg-gray-100 text-blue-600 font-semibold"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Right-side content area */}
        <div className="content-area flex-grow w-full">
          {tabs.find((tab) => tab.name === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};

export default OfficeConfig;